import { DecimalPipe, DatePipe } from '@angular/common';
import { Component, ElementRef, EventEmitter, Input, Output, TemplateRef, ViewChild } from '@angular/core';
import { TableSubAccountsService } from './table-sub-accounts.service';
import { NgbDateStruct, NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { ExtratoService } from '../extrato/extrato.service';
import { ToastrService } from "ngx-toastr";
import { saveAs } from 'file-saver';
import { PdfService } from 'src/app/shared/services/pdf.service';
import { finalize, firstValueFrom, Subscription } from 'rxjs';
import { TranslateService, LangChangeEvent } from '@ngx-translate/core';
import { AuthService } from 'src/app/shared/services/auth.service';


@Component({
  selector: 'app-table-sub-accounts',
  templateUrl: './table-sub-accounts.component.html',
  styleUrls: ['./table-sub-accounts.component.scss'],
  providers: [TableSubAccountsService, DecimalPipe, DatePipe]
})
export class TableSubAccountsComponent {
  private transactionDetailsTpl!: TemplateRef<any>;
  public dataInitial!: NgbDateStruct;
  public dataFinal!: NgbDateStruct;
  public transactionType: string = '';
  public selectedStatus: string = '';
  public selectedOrigin: string = '';
  public selectedApplciation: string = '';
  public personName: string = '';
  public searchType: string = '';
  public page: number = 1;
  public pageSize: number = 20;
  public total: number = 0;
  public receiptTemplate: string = '';
  public bankProvider: Array<any> = [];
  public nameColumn: string = '';
  public account: any;
  public accounts: Array<any> = [];
  public selectedTransaction: any;
  public selectedCrypto: any = null;
  public canDownloadReceipt = false;
  public canResendWebhook = false;
  public isReprocessing = false;
  public tableRowForReceipt: any = null;
  public switchingId: string | null = null;
  public selectedAccount: any = null;
  public updatingId: string | null = null;
  public selectedUser: any = null;
  public validationCode: string = '';
  public validatingTotp: boolean = false;
  public errorMessage: string = '';
  public pendingUser: any = null;
  public isLoaded = true;
  langChangeSub!: Subscription;

  originMap: any = {
    BRL: { flag: 'assets/flags/4x3/br.svg', gmtOffset: -3, name: 'Brasil' },
    MXN: { flag: 'assets/flags/4x3/mx.svg', gmtOffset: -6, name: 'Mexico' },
    CLP: { flag: 'assets/flags/4x3/cl.svg', gmtOffset: -4, name: 'Chile' },
    PEN: { flag: 'assets/flags/4x3/pe.svg', gmtOffset: -5, name: 'Peru' },
    COP: { flag: 'assets/flags/4x3/co.svg', gmtOffset: -5, name: 'Colombia' },
    PHP: { flag: 'assets/flags/4x3/ph.svg', gmtOffset: +8, name: 'Phillipines' }
  };

  @ViewChild('requestTOTPCode') validateToken!: ElementRef | any;
  @Output() loading = new EventEmitter<boolean>();
  @Output() switched = new EventEmitter<void>();
  @Output() statusChanged = new EventEmitter<void>();


  constructor(
    private tableSubAccountsService: TableSubAccountsService,
    private toastr: ToastrService,
    private pdfService: PdfService,
    private translate: TranslateService,
    private modal: NgbModal,
    private datePipe: DatePipe,
    private decimal: DecimalPipe,
    private auth: AuthService) {
    const currentDate = new Date();
    currentDate.setDate(currentDate.getDate());

    this.dataInitial = { year: currentDate.getFullYear(), month: currentDate.getMonth() + 1, day: currentDate.getDate() }
    this.dataFinal = { year: new Date().getFullYear(), month: new Date().getMonth() + 1, day: new Date().getDate() }
    this.selectedStatus = 'REALIZADO';
    this.loadData();
  }



  ngOnInit(): void {
    this.setTranslatedNameColumn();

    this.langChangeSub = this.translate.onLangChange.subscribe(() => {
      this.setTranslatedNameColumn();
    })
  }

  loadData(searchTerm?: string): void {
    this.loading.emit(true);

    this.tableSubAccountsService
      .getAccountMulti(this.page, this.pageSize, searchTerm)
      .subscribe({
        next: (body) => {
          const raw = body?.accounts ?? [];
          this.accounts = raw
            .map(a => ({ ...a, todaysSales: a?.currentValue ?? 0 }))
            .sort((a, b) => {
              const originCompare = (a.originCurrency || '').localeCompare(b.originCurrency || '');
              if (originCompare !== 0) {
                return originCompare; 
              }

              return (b?.readyAmount ?? 0) - (a?.readyAmount ?? 0);
            });

          this.total = Number((body as any)?.totalPage ?? raw.length);
        },
        error: () => {
          this.accounts = [];
          this.total = 0;
          this.loading.emit(false);
          this.toastr.error('Erro ao buscar contas');
        },
        complete: () => {
          this.loading.emit(false);
        }
      });
  }

  onToggleClick(ev: MouseEvent, modalTpl: TemplateRef<any>, acc: any) {
    ev.preventDefault();
    ev.stopPropagation();
    this.selectedUser = { ...acc, name: acc.description };
    this.modal.open(modalTpl, { size: 'sm', centered: true, backdrop: 'static' });
  }


  toggleActive(user: any, activeModalRef: any) {
    activeModalRef.dismiss();
    this.pendingUser = user;
    this.validationCode = '';
    this.errorMessage = '';
    this.openTotpModal();
  }


  private openTotpModal() {
    this.modal.open(this.validateToken, {
      backdrop: 'static',
      keyboard: true,
      centered: true,
      size: 'sm',
    });
  }


  async pasteTotpCode() {
    try {
      const text = await navigator.clipboard.readText();
      this.validationCode = (text || '').trim();
    } catch {
      this.toastr.error('Erro ao colar o código do clipboard');
    }
  }


  async validateTotp() {
    if (this.validatingTotp) return;
    this.validatingTotp = true;
    this.errorMessage = '';

    try {
      const res = await this.auth.validateTotpCode(this.validationCode);
      const isValid = !!res?.isValid;

      if (isValid) {
        this.modal.dismissAll();
        await this.doToggleUserActive(this.pendingUser);
        this.pendingUser = null;
        this.validationCode = '';
      } else {
        this.errorMessage = 'Código de autenticação inválido!';
      }
    } catch {
      this.errorMessage = 'Falha ao validar o código de autenticação.';
    } finally {
      this.validatingTotp = false;
    }
  }


  private async doToggleUserActive(user: any) {
    const newValue = !user.active;
    this.updatingId = user.id;

    return new Promise<void>((resolve) => {
      this.tableSubAccountsService.updateActive(user.id, newValue).subscribe({
        next: () => {
          const row = this.accounts.find(a => a.id === user.id);
          if (row) row.active = newValue;
          this.toastr.success(newValue ? 'Subconta ativada com sucesso!' : 'Subconta desativada com sucesso!');

          this.loadData();
          this.statusChanged.emit();
          resolve();
        },
        error: () => {
          this.toastr.error('Falha ao atualizar status da subconta.');
          resolve();
        },
        complete: () => {
          this.updatingId = null;
          this.selectedUser = null;
        }
      });
    });
  }

  onSwitchAccount(accountId: string) {
  if (this.switchingId) return;
  this.switchingId = accountId;

  this.tableSubAccountsService.switchAccount(accountId).subscribe({
    next: (res) => {
      this.auth.setUserLoggedIn(res);

      this.auth.preloadAccountInfo();

      this.toastr.success('Conta alternada com sucesso.');
      this.page = 1;
      this.loadData();
      this.switched.emit();
      location.reload();

    },
    error: () => {
      this.toastr.error('Falha ao alternar conta.');
    },
    complete: () => {
      this.switchingId = null;
    }
  });
}


  setTranslatedNameColumn(): void {
    this.translate.get(['common.license', 'common.split']).subscribe(translations => {
      if (this.account?.nameColumn?.includes('LICENCIADO')) {
        this.nameColumn = translations['common.license'];
      } else {
        this.nameColumn = translations['common.split'];
      }
    });
  }

  isValidPixDate(transactionDate: string): boolean {
    const targetDate = new Date('2025-02-05T00:00:00Z');
    const transactionDateObj = new Date(transactionDate);

    return transactionDateObj.getTime() >= targetDate.getTime();
  }

  isValidTefDate(transactionDate: string): boolean {
    const targetDate = new Date('2025-05-02T00:00:00Z');
    const transactionDateObj = new Date(transactionDate);

    return transactionDateObj.getTime() >= targetDate.getTime();
  }



  public getBankProvider() {
    this.tableSubAccountsService.getBankProvider().subscribe(
      value => {
        this.bankProvider = value.data;
      }
    )
  }


  openDetails(row: any): void {
    this.tableRowForReceipt = row;

    this.canDownloadReceipt =
      row.tipo === 'Saque' &&
      (
        (row.origem === 'PIX' && this.isValidPixDate(row.data)) ||
        (row.origem === 'TEF' && this.isValidTefDate(row.data))
      );

    this.canResendWebhook =
      ['REALIZADO', 'CANCELADO'].includes(row.status) &&
      ['API', 'TEF'].includes(row.aplicacao);

    this.tableSubAccountsService.getTransactionDetail(row.codigo)
      .then(resp => {
        const detail = resp.transaction ?? resp;
        this.selectedTransaction = {
          ...detail,
          cryptoTransaction: resp.cryptoTransaction ?? null,
          wallet: resp.wallet ?? null,
          symbol: resp.symbol ?? null
        };

        this.modal.open(this.transactionDetailsTpl, {
          centered: true,
          backdrop: 'static',
          windowClass: 'tall-modal',
          scrollable: true,
          size: 'lg'
        });
      })
      .catch(() => this.toastr.error('Erro ao buscar detalhes'));
  }

  fmtDate(d: string) { return this.datePipe.transform(d, 'dd/MM/yyyy HH:mm:ss', 'UTC'); }
  fmtMoney(v: number) { return this.decimal.transform(v, '1.2-2', 'pt-BR'); }

  public getAccount() {
    this.tableSubAccountsService.getAccount().then(
      value => {
        this.account = value;
        if (this.account?.nameColumn) {
          if (this.account.nameColumn.includes('LICENCIADO')) {
            this.nameColumn = this.translate.instant('common.license');
          } else {
            this.nameColumn = this.translate.instant('common.split');
          }
        }
      }
    ).catch(error => {
      console.error('Error fetching account:', error);
    });
  }

  formatStatusClass(status: string): string {
    return 'status-' + status.toLowerCase().replace(/ /g, '-');
  }

  pageChange() {
    this.loadData();
  }

  async resendWebhook(transaction: any) {
    if (this.isReprocessing) { return; }
    this.isReprocessing = true;

    this.toastr.info('Reenviando webhook…', '', { timeOut: 2000 });

    try {
      await this.tableSubAccountsService.resendWebhook([transaction.id]);
      this.toastr.success('Webhook reenviado com sucesso');
    } catch {
      this.toastr.error('Falha ao reenviar webhook');
    } finally {
      this.isReprocessing = false;
    }
  }

  async downloadReceipt(rowFromGrid: any) {
    this.toastr.info('Gerando comprovante…', '', {
      timeOut: 2000, positionClass: 'toast-top-right',
    });

    try {
      const payload = rowFromGrid;

      const response = await firstValueFrom(this.pdfService.reportWithdraw(payload));
      const bytes = atob(response);
      const buf = new Uint8Array(bytes.length);
      for (let i = 0; i < bytes.length; i++) buf[i] = bytes.charCodeAt(i);

      saveAs(new Blob([buf], { type: 'application/pdf' }), 'comprovante.pdf');

      this.toastr.success('Comprovante gerado com sucesso!', 'Sucesso', {
        timeOut: 3000, positionClass: 'toast-top-right',
      });
    } catch (err: any) {
      const msg = err?.error?.mensagem || err?.message || 'Falha ao gerar comprovante.';
      this.toastr.error(msg, 'Erro', {
        timeOut: 3000, positionClass: 'toast-top-right',
      });
    }
  }
}


